
import slugify from 'slugify'
export default {
  props: {
    module: Object,
    group: Object
  },

  data () {
    return {
      isReady: false,
      template: {
        text: {
          module: 'textarea',
          rows: 6
        }
      }
    }
  },

  watch: {
    group: {
      handler (val) {
        this.$emit('valid', true)
      },
      deep: true,
      immediate: true
    }
  },

  computed: {
    _group: {
      set (value) {
        this.$emit('update:group', value)
      },

      get () {
        return this.group
      }
    }
  },

  mounted () {
    if (!this.group) this._group = {}
    this.isReady = true
  }
}
